<template>
    <div>
        <h1>Contact</h1>
        <div>{{msg}} {{inputText}}</div>
        <input type="text" v-model="inputText"/>
        <button @click="clearText()">Clear</button>

        <ul>
            <li v-for="(v,k) in list" :key="k">
                {{v}}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            msg: '',
            inputText: '',
            list: [1,1,1],
        };
    },
    created: function(){
        var x='aa';
        console.log(x);
        this.init('hello world');
    },
    methods: {
        init: function(str) {
            this.msg = str;

            for (var i of this.list) {
                i = i+1;
            }
        },
        clearText: function(){
            this.inputText = '';
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "./contact.scss";
</style>
